import ApplicationController from './application_controller'

export default class extends ApplicationController {
  sortResults(e) {
    location.assign(e.target.value)
  }
}
